export const GET_PRO_EXAMS_QUERY = `query getProExamsQuery {
    wft_course {
    description
    duration
    id
    name
    created_at
    created_by_details {
      email
      name
    }
    workflows_aggregate {
      aggregate {
        count
      }
    }
  }
}`;
